module.exports = __webpack_public_path__ + "static/assets/3193f3bb199afc585269a205e9a9c6f3.gif";